/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    h2: "h2",
    p: "p",
    code: "code",
    a: "a",
    pre: "pre",
    ul: "ul",
    li: "li",
    h3: "h3",
    strong: "strong",
    h4: "h4"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Making changes"
    }), "\n", _jsx(_components.h2, {
      children: "Check out a new branch"
    }), "\n", _jsxs(_components.p, {
      children: ["Make a new working branch and name it e.g. ", _jsx(_components.code, {
        children: "fix/my-branch-name"
      }), " or ", _jsx(_components.code, {
        children: "feat/my-feature-name"
      }), ". Check out ", _jsx(_components.a, {
        href: "/contribute/style-guides/git",
        children: "Git convention"
      }), " for naming."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "# Make a Feature branch\n$ git checkout -b feat/my-feature\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Add changes"
    }), "\n", _jsxs(_components.p, {
      children: ["Inside ", _jsx(_components.code, {
        children: "./packages/dnb-eufemia"
      }), " you will find the directory ", _jsx(_components.code, {
        children: "/src/components"
      }), " or ", _jsx(_components.code, {
        children: "/src/extensions"
      }), ". There you can place a new directory with all the necessary sub folders. As a reference, take a look at Component folder section in ", _jsx(_components.a, {
        href: "/contribute/first-contribution/before-started#component-folder",
        children: "Before getting started"
      }), "."]
    }), "\n", _jsxs(_components.p, {
      children: ["Run an environment with either ", _jsx(_components.code, {
        children: "yarn dev"
      }), " (for Storybook) or ", _jsx(_components.code, {
        children: "yarn start"
      }), " (for Eufemia Portal). Make sure you follow the ", _jsx(_components.a, {
        href: "/contribute/style-guides/coding",
        children: "Code guide"
      }), " under development."]
    }), "\n", _jsx(_components.h2, {
      children: "Styling, CSS and SCSS of components"
    }), "\n", _jsx(_components.p, {
      children: "Each component has two or three SCSS files."
    }), "\n", _jsx(_components.p, {
      children: "All layout and position related styles go here:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-eufemia/src/components/button/style/dnb-button.scss"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "CSS packages"
    }), "\n", _jsxs(_components.p, {
      children: ["SCSS file names starting with ", _jsx(_components.code, {
        children: "dnb-"
      }), " are later possible to get imported as individual packages:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-eufemia/src/components/button/style/dnb-button.scss"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "Style dependencies"
    }), "\n", _jsxs(_components.p, {
      children: ["In order to test related style dependencies of components, we add style imports in the ", _jsx(_components.code, {
        children: "deps.scss"
      }), " file, which again is used in Jest tests to perform a snapshot comparison:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-eufemia/src/components/button/style/deps.scss"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h3, {
      children: "SCSS Theming"
    }), "\n", _jsxs(_components.p, {
      children: ["Styles that belong to a \"theming footprint\" – like colors or individual variants – can be put inside the ", _jsx(_components.code, {
        children: "/themes"
      }), " directory:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-eufemia/src/components/button/style/themes/dnb-button-theme-ui.scss"
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Theming file names ending with ", _jsx(_components.code, {
        children: "-ui"
      }), " will during the package release get packed into the global theming package. More details in the ", _jsx(_components.a, {
        href: "/uilib/usage/customisation/theming",
        children: "theming section"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      children: "SCSS utilities"
    }), "\n", _jsxs(_components.p, {
      children: ["Use the same SASS setup as all the other components. You may re-use all the ", _jsx(_components.a, {
        href: "/uilib/helpers/classes",
        children: "helper classes"
      }), ":"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-eufemia/src/style/core/utilities.scss"
        })
      }), "\n"]
    }), "\n", _jsx(_components.h2, {
      children: "Create a local build"
    }), "\n", _jsxs(_components.p, {
      children: ["Next, we need to create a local build (prebuild) by using ", _jsx(_components.code, {
        children: "yarn build"
      }), " again."]
    }), "\n", _jsx(_components.p, {
      children: "Running the build command will walk through all parts and tie together all needed parts (index files of new components) in order to generate valid build bundles."
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-bash",
        children: "$ yarn build\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["You can find the output in the ", _jsx(_components.code, {
        children: "./packages/dnb-eufemia/build"
      }), " folder."]
    }), "\n", _jsx(_components.h2, {
      children: "Additional component support"
    }), "\n", _jsx(_components.h3, {
      children: "Locale support"
    }), "\n", _jsxs(_components.p, {
      children: ["Put your translation inside: ", _jsx(_components.code, {
        children: "./packages/dnb-eufemia/src/shared/locales/nb-NO.js"
      }), " as well as to the ", _jsx(_components.code, {
        children: "en-GB.js"
      }), " file:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-js",
        children: "export default {\n  'nb-NO': {\n    MyComponent: {\n      myString: '...',\n    },\n  },\n}\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "And use it as so:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Context } from '../../shared'\nimport { extendPropsWithContext } from '../../shared/component-helper'\n\nimport type { LocaleProps } from '../../shared/types'\n\nexport type ComponentProps = {\n  myParam?: string\n}\nexport type ComponentAllProps = ComponentProps &\n  LocaleProps &\n  React.HTMLProps<HTMLElement>\n\nconst defaultProps = {\n  myParam: 'value',\n}\n\nfunction MyComponent(props: ComponentAllProps) {\n  const context = React.useContext(Context)\n\n  const { myString } = extendPropsWithContext(\n    props,\n    defaultProps,\n    context.getTranslation(props).MyComponent, // details below 👇\n    // ...\n  )\n\n  // Use myString ...\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["The function ", _jsx(_components.code, {
        children: "getTranslation"
      }), " will along with the properties support both ", _jsx(_components.code, {
        children: "locale"
      }), " and the HTML ", _jsx(_components.code, {
        children: "lang"
      }), " attribute. This way, these properties can be set by a component basis and a context basis."]
    }), "\n", _jsx(_components.h3, {
      children: "Provider support"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Context } from '../../shared'\nimport { extendPropsWithContext } from '../../shared/component-helper'\n\nexport type ComponentProps = {\n  myParam?: string\n}\nexport type ComponentAllProps = ComponentProps &\n  LocaleProps &\n  React.HTMLProps<HTMLElement>\n\nconst defaultProps = {\n  myParam: 'value',\n}\n\nfunction MyComponent(props: ComponentAllProps) {\n  const context = React.useContext(Context)\n\n  const { myParam, ...rest } = extendPropsWithContext(\n    props,\n    defaultProps,\n    context.MyComponent,\n    // ...\n  )\n\n  // Use myParam and spread the ...rest\n}\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "\"Form element\" components"
    }), "\n", _jsx(_components.p, {
      children: "Form elements, like input, checkbox, slider etc. should include some extra functionality in order to be used in various situations."
    }), "\n", _jsxs(_components.p, {
      children: ["Basically, components we would place inside a HTML ", _jsx(_components.code, {
        children: "<form>"
      }), " element."]
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Label vs fieldset/legend"
      })
    }), "\n", _jsx(_components.p, {
      children: "They should be declared as a form element:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "FormComponent._formElement = true\n"
      })
    }), "\n", _jsx(_components.p, {
      children: "This helps e.g. to detect automated determination of label vs fieldset/legend."
    }), "\n", _jsx(_components.p, {
      children: _jsx(_components.strong, {
        children: "Spacing"
      })
    }), "\n", _jsx(_components.p, {
      children: "And they should be declared to support spacing props as well:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "FormComponent._supportsSpacingProps = true\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["This is needed in order to fully support ", _jsx(_components.a, {
        href: "/uilib/layout/flex/",
        children: "Flex"
      }), " layouts."]
    }), "\n", _jsxs(_components.h4, {
      children: ["Usage of ", _jsx(_components.code, {
        children: "pickFormElementProps"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In order to support form element props, such as ", _jsx(_components.code, {
        children: "vertical"
      }), " or ", _jsx(_components.code, {
        children: "labelDirection"
      }), ", you can use ", _jsx(_components.code, {
        children: "pickFormElementProps"
      }), ", so only valid properties will effected the component."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Context } from '../../shared'\nimport { extendPropsWithContext } from '../../shared/component-helper'\nimport { pickFormElementProps } from '../../shared/helpers/filterValidProps'\n\nconst defaultProps = {\n  myParam: 'value',\n}\n\nfunction FormComponent(props: Types) {\n  const context = React.useContext(Context)\n\n  const { myParam, skeleton, ...rest } = extendPropsWithContext(\n    props,\n    defaultProps,\n    pickFormElementProps(context?.formElement)\n    context.FormComponent,\n  )\n\n  // Use myParam and spread the ...rest\n}\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Spacing support"
    }), "\n", _jsxs(_components.p, {
      children: ["It depends from case to case on how you would make ", _jsx(_components.a, {
        href: "/uilib/layout/space",
        children: "spacing"
      }), " support available. But you may always give the developer to send in the spacing properties to the very root element of your component."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Context } from '../../shared'\nimport classnames from 'classnames'\nimport {\n  validateDOMAttributes,\n  extendPropsWithContext,\n} from '../../shared/component-helper'\nimport { createSpacingClasses } from '../space/SpacingHelper'\n\nimport type { SpacingProps } from '../../shared/types'\n\nexport type ComponentProps = {\n  myParam?: string\n}\nexport type ComponentAllProps = ComponentProps & SpacingProps\n\nconst defaultProps = {\n  myParam: 'value',\n}\n\nfunction MyComponent(props: ComponentAllProps) {\n  const context = React.useContext(Context)\n\n  const { myParam, className, ...rest } = extendPropsWithContext(\n    props,\n    defaultProps,\n    // ...\n  )\n\n  // This helper will remove e.g. all spacing properties so you get only valid HTML attributes\n  validateDOMAttributes(props, rest)\n\n  // This helper will add needed spacing css classes based on the given properties\n  rest.className = classnames(\n    'dnb-my-component',\n    createSpacingClasses(props),\n    className,\n  )\n\n  // Spread the ...rest on your root element\n}\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "Skeleton support"
    }), "\n", _jsxs(_components.p, {
      children: ["It depends from case to case on how you would make skeleton support available. There are also more info on how to create a ", _jsx(_components.a, {
        href: "/uilib/components/skeleton#create-custom-skeleton",
        children: "custom skeleton"
      }), ". But in case your component supports the ", _jsx(_components.code, {
        children: "skeleton"
      }), " boolean property, then you may ensure it both can be set locally on the component, and it reacts on the global Context."]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import { Context } from '../../shared'\nimport { extendPropsWithContext } from '../../shared/component-helper'\nimport {\n  skeletonDOMAttributes,\n  createSkeletonClass,\n} from '../skeleton/SkeletonHelper'\n\nimport type { SkeletonShow } from '../skeleton/Skeleton'\n\nexport type ComponentProps = {\n  /**\n   * Skeleton should be applied when loading content\n   * Default: null\n   */\n  skeleton?: SkeletonShow\n}\nexport type ComponentAllProps = ComponentProps &\n  React.HTMLProps<HTMLElement>\n\nconst defaultProps = {}\n\nfunction MyComponent(props: ComponentAllProps) {\n  const context = React.useContext(Context)\n\n  const { skeleton, className, ...rest } = extendPropsWithContext(\n    props,\n    defaultProps,\n    { skeleton: context?.skeleton },\n    // ...\n  )\n\n  // This helper will add some needed HTML attributes like \"disabled\", \"aria-disabled\" and \"aria-label\"\n  skeletonDOMAttributes(rest, skeleton, context)\n\n  // This helper will add needed skeleton css classes in order to create a custom skeleton\n  rest.className = createSkeletonClass(\n    'shape',\n    skeleton,\n    context,\n    className,\n  )\n\n  // Use skeleton and spread the ...rest\n}\n"
      })
    }), "\n", _jsx(_components.h3, {
      children: "TypeScript types"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-tsx",
        children: "import React from 'react'\nimport type { SpacingProps } from '../../shared/types'\nimport type { ComponentProps } from './my-component/types'\n\nexport type * from './new-component/types'\n\nexport type ComponentAllProps = ComponentProps &\n  React.HTMLProps<HTMLElement>\n\nfunction MyComponent(props: ComponentAllProps) {}\n"
      })
    }), "\n", _jsx(_components.h2, {
      children: "Write documentation"
    }), "\n", _jsx(_components.p, {
      children: "All components have their own directory inside:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.code, {
          children: "./packages/dnb-design-system-portal/src/docs/uilib/..."
        })
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["You may have a look at ", _jsx(_components.a, {
        href: "/contribute/style-guides/documentation",
        children: "Documentation guide"
      }), " and existing docs in order to get the right structure."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
